var React = require('react');

function SoundOn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.8574 4.19922C16.6256 6.12359 16.6256 9.24365 14.8574 11.168","strokeWidth":"1.25","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M16.6992 1.92383C19.6331 5.11686 19.6331 10.2932 16.6992 13.4862","strokeWidth":"1.25","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M10.8028 1.36161L5.17352 4.75832H1.96577C1.29213 4.75832 0.746094 5.30045 0.746094 5.96926V9.3506C0.746094 10.0194 1.29213 10.5615 1.96577 10.5615H5.17352L10.8028 13.9583C11.1438 14.1641 11.5801 13.9205 11.5801 13.5242V1.79569C11.5801 1.3998 11.1438 1.15621 10.8028 1.36161Z","strokeWidth":"1.25","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

SoundOn.defaultProps = {"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none"};

module.exports = SoundOn;

SoundOn.default = SoundOn;
